/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */
import * as strings from '@touchplan/strings';
import { SortBy } from './SortBy';

export const sortStrings = {
	[SortBy.Role]: strings.REPORT_SORTBY_ROLE,
	[SortBy.Date]: strings.REPORT_SORTBY_DATE,
};
